// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__2V-E6","itemTitle":"ClientEmergencyInfo_itemTitle__98TA6","itemText":"ClientEmergencyInfo_itemText__1kD2z"};